import React from 'react';
import { Card } from './Card';
import { Diff } from '../Diff';
import { BoxIcon } from '../icons/BoxIcon';
import { ChartInput } from '../../model/ChartInput';
import { getDiff } from '../../model/Diff';

const TopFiveCard = ({ input, previousInput }: Props) => {
  const renderDiff = (label: string, value: number) => {
    const index = previousInput.labels.indexOf(label);
    const previousValue = index >= 0 ? previousInput.datasets[0].data[index] as number : 0;
    return <Diff value={getDiff(value, previousValue)} />;
  }

  return (
    <Card>
      <div className="card-body">
        <h5 className="card-title mb-4">Top 5 product</h5>
        <div className="row">
          {
            input.labels.slice(0, 5).map((i, index) => <div key={i} className="col-6 col-lg-12 d-flex align-items-center mb-3">
              <BoxIcon />
              <span className="flex-grow-1 text-black ms-3">{i}</span>
              <span className="me-2 fs-7 text-right text-muted">{input.datasets[0].data[index].toString()}</span>
              <div className="text-right">
                {renderDiff(i, input.datasets[0].data[index] as number)}
              </div>
            </div>)
          }
        </div>
      </div>
    </Card>);
}

interface Props {
  input: ChartInput,
  previousInput: ChartInput
}

export { TopFiveCard };